"use client";
import Link from "next/link";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center p-4 bg-gradient-to-br from-[#463a33]/5 to-[#ff7043]/5">
      <h1 className="text-6xl md:text-8xl font-bold text-[#ff7043] mb-4">
        404
      </h1>
      <h2 className="text-xl md:text-2xl text-[#463a33]/90 mb-2">
        Oops! The page you're looking for doesn't exist.
      </h2>
      <p className="text-base md:text-lg text-[#463a33]/80 mb-6">
        It may have been moved or deleted.
      </p>
      <Link href="/" passHref>
        <button className="px-6 py-3 rounded-xl bg-[#ff7043] text-white font-semibold hover:bg-[#ff7043]/90 transition-all duration-200 transform hover:scale-[1.02] shadow-lg">
          Go Home
        </button>
      </Link>
    </div>
  );
}
